import type { ReactNode } from 'react';

/** 下層ページセクションの最大幅（Tailwind max-w-6xl と同値） */
export const SUBPAGE_CONTENT_WIDTH = '72rem';

/** max まで自動で広がり、それより狭い画面では流動的に縮む */
export const subPageContentClass = 'subpage-content';

type SubPageContentProps = {
  children: ReactNode;
  className?: string;
};

export default function SubPageContent({ children, className = '' }: SubPageContentProps) {
  return <div className={`${subPageContentClass} ${className}`.trim()}>{children}</div>;
}
